// @json
import security from './security/authentication.json';
import siteEnrollments from './strategies/site-enrollments.json';
import siteTesting from './testing/site-testing.json';
import sitesDetails from './locations/sites-detail.json';
import siteTestSchedule from './testing/test-sessions.json';

export default {
  security,
  siteEnrollments,
  siteTesting,
  sitesDetails,
  siteTestSchedule
};
